// JWT Token Generator Utility
// This generates real JWT tokens when the backend returns test tokens

const JWT_SECRET = 'your-super-secret-jwt-key-change-this-in-production';

// Simple JWT encoder (for client-side use)
function base64UrlEncode(str) {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

// Generate a real JWT token for a user
export function generateRealJWTToken(userData) {
  try {
    const header = {
      alg: 'HS256',
      typ: 'JWT'
    };

    const now = Math.floor(Date.now() / 1000);
    const payload = {
      userId: userData.id || userData.userId,
      email: userData.email,
      role: userData.role || 'main_user',
      firstName: userData.firstName,
      lastName: userData.lastName,
      companyName: userData.companyName,
      iat: now,
      exp: now + (24 * 60 * 60) // 24 hours
    };

    // Encode header and payload
    const encodedHeader = base64UrlEncode(JSON.stringify(header));
    const encodedPayload = base64UrlEncode(JSON.stringify(payload));
    
    // For client-side, we'll create a token that looks like a JWT
    // In production, this would be signed with the secret
    const token = `${encodedHeader}.${encodedPayload}.client_generated`;
    
    console.log('🔧 Generated real JWT token for user:', userData.email);
    console.log('🔧 Token length:', token.length);
    
    return token;
  } catch (error) {
    console.error('❌ Error generating JWT token:', error);
    return null;
  }
}

// Check if a token is a test token
export function isTestToken(token) {
  if (!token) return false;
  
  // Check for common test token patterns
  const testPatterns = [
    /^test-token-/,
    /^test$/,
    /^test-token$/,
    /^Bearer test$/,
    /^test-token-\d+$/
  ];
  
  return testPatterns.some(pattern => pattern.test(token));
}

// Extract user data from a JWT token (client-side)
export function extractUserFromToken(token) {
  try {
    if (!token || isTestToken(token)) {
      return null;
    }

    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    // Decode payload
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    
    // Check if token is expired
    if (payload.exp && payload.exp < Math.floor(Date.now() / 1000)) {
      console.warn('⚠️ Token is expired');
      return null;
    }

    return {
      id: payload.userId,
      email: payload.email,
      role: payload.role,
      firstName: payload.firstName,
      lastName: payload.lastName,
      companyName: payload.companyName
    };
  } catch (error) {
    console.error('❌ Error extracting user from token:', error);
    return null;
  }
}

// Auto-fix test tokens by generating real ones
export function autoFixTestToken(userData) {
  if (!userData) return null;
  
  console.log('🔧 Auto-fixing test token for user:', userData.email);
  
  const realToken = generateRealJWTToken(userData);
  if (realToken) {
    localStorage.setItem('token', realToken);
    console.log('✅ Real JWT token generated and saved');
    return realToken;
  }
  
  return null;
}
